import React from 'react';
import RowActions from './RowActions';

export default [
  {
    name: 'Name',
    selector: (row) => row.attributes.file_name,
    sortable: true,
  },
  {
    name: 'Type',
    selector: (row) => row.attributes.resource_type,
    sortable: true,
  },
  {
    name: 'OpenAI File Id',
    selector: (row) => row.attributes.openai_file_id,
    sortable: true,
  },
  {
    name: '',
    cell: (row) => <RowActions row={row} />,
    width: '100px',
  },
];
